// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cookie-consent-content{background-color:#fff;padding:1em}.cookie-consent-classification{padding:10px 15px;margin:20px;background-color:#fbfbfb;border-radius:5px}@media(min-width: 900px){.desktop-width{width:900px}}@media(max-width: 360px){.cookie-consent-settings-link{display:block;margin-bottom:1em}}", ""]);
// Exports
module.exports = exports;
